import { AppContextType } from "../../../../context/AppContext";
import useAppContext from "../../../../hooks/useAppContext";
import { IndividualPersonType } from "../../../../static/types/commonTypes/individualType";
import IndividualPerson from "../../../commonComponents/IndividualPerson";

interface props {
    setSubmissive: (submissive: boolean) => void
}

const NotaryReceivingOppositions: React.FC<props> = ({
    setSubmissive
}) => {

    const {

        notaryData, setNotaryData,

        individualNotary, setIndividualNotary,
        individualNotaryValidity, setIndividualNotaryValidity,
        individualNotaryChecked, setIndividualNotaryChecked,

    } = useAppContext() as AppContextType

    const updateNotary = (data: Partial<IndividualPersonType>) => setIndividualNotary({...individualNotary,...data})

    return (
    <div className="contenair my-4">
        <div className="row mb-3">
            <label htmlFor="notary" className="col-sm-auto col-form-label">
                Notaire
            </label>
            <div className="col-sm-8">
                <select
                className='form-select w-auto'
                id="notary"
                name="notary"
                onChange={(e) => {
                    setSubmissive(false)
                    setNotaryData(Number(e.target.value))
                }}
                value={notaryData}
                >
                    <option value={0}>Même notaire officiant</option>
                    <option value={1}>Notaire différent du notaire officiant</option>
                </select>
            </div>
            {
                notaryData === 1 &&
                <div className="mt-3">
                    <IndividualPerson
                        individual={individualNotary}
                        checked={individualNotaryChecked}
                        changeIndividual={updateNotary}
                        onValidationChange={(isValid: boolean) => setIndividualNotaryValidity(isValid)}
                        draftFieldName = "individualNotary"
                    />
                </div>
            }
        </div>
    </div>
)}
export default NotaryReceivingOppositions;